export default "__VITE_ASSET__CNF4ktju__"